import React, { useEffect } from "react";
import DistributorList from "../../components/admin/DistributorList";


const DistributorListPage = () => {

    useEffect(() => {
        document.body.id = "distributorList-002";
      }, []);

  return (
    <div>
   <DistributorList />
    </div>
  );
};

export default DistributorListPage;
